<template>
  <div id="newsletter-recipient-search">
    <search-form
      legend="Recipients"
      :pageRef="$parent"
      :searchUrl="searchUrl"
    />
  </div>
</template>
<script>
import SearchForm from '@/components/PagedSearchFieldForm'

export default {
  data () {
    return {
      recipients: []
    }
  },

  computed: {
    searchUrl () {
      return this.apiUrl(
        this.newsletterId ? '/newsletters/' + this.newsletterId + '/recipients/search' : '/targeted_emails/' + this.emailId + '/recipients/search',
        true
      )
    }
  },

  props: {
    emailId: {
      type: [ Number, String ],
      default: undefined
    },

    newsletterId: {
      type: [ Number, String ],
      default: undefined
    }
  },

  components: {
    'search-form': SearchForm
  }
}
</script>




// WEBPACK FOOTER //
// src/components/EmailRecipientSearch.vue